import type { FC } from 'react';
import { useTheme } from '@mui/material/styles';
import Main from 'layouts/Main';
import Container from 'components/Container';
import useMediaQuery from '@mui/material/useMediaQuery';
import Topic from './components/Topic';
import Introduction from './components/Introduction';
import Contracts from './components/Contracts';
import Payroll from './components/Payroll';
import Compliance from './components/Compliance';
import DataProtection from './components/DataProtection';
import LogoSliders from './components/LogoSliders';

const Compliant: FC = () => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  return (
    <Main colorInvert={false}>
      <Container id="compliant-topic" data-aos={isMd ? 'fade-left' : 'fade-up'}>
        <Topic />
      </Container>
      <Container
        id="compliant-introduction"
        data-aos={isMd ? 'fade-right' : 'fade-up'}
        paddingY={{ xs: 4, sm: 6, md: 6 }}
      >
        <Introduction />
      </Container>
      <Container
        id="compliant-contracts"
        data-aos={isMd ? 'fade-left' : 'fade-up'}
        paddingY={{ xs: 4, sm: 6, md: 6 }}
      >
        <Contracts />
      </Container>
      <Container
        id="compliant-payroll"
        data-aos={isMd ? 'fade-right' : 'fade-up'}
        paddingY={{ xs: 4, sm: 6, md: 6 }}
      >
        <Payroll />
      </Container>
      <Container
        id="compliant-compliance"
        data-aos={isMd ? 'fade-left' : 'fade-up'}
        paddingY={{ xs: 4, sm: 6, md: 6 }}
      >
        <Compliance />
      </Container>
      <Container
        id="compliant-data-protection"
        data-aos={isMd ? 'fade-right' : 'fade-up'}
        paddingY={{ xs: 4, sm: 6, md: 6 }}
      >
        <DataProtection />
      </Container>
      <Container
        id="compliant-data-protection"
        data-aos={isMd ? 'fade-left' : 'fade-up'}
        paddingY={{ xs: 4, sm: 6, md: 6 }}
      >
        <LogoSliders />
      </Container>
    </Main>
  );
};

export default Compliant;
